import { render, staticRenderFns } from "./ShowVideoModal.vue?vue&type=template&id=b83e72f4&"
import script from "./ShowVideoModal.vue?vue&type=script&lang=ts&"
export * from "./ShowVideoModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1650423547/src/github.com/trainn-tech/trainn-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b83e72f4')) {
      api.createRecord('b83e72f4', component.options)
    } else {
      api.reload('b83e72f4', component.options)
    }
    module.hot.accept("./ShowVideoModal.vue?vue&type=template&id=b83e72f4&", function () {
      api.rerender('b83e72f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/modals/ShowVideoModal.vue"
export default component.exports